// The embedded Business Intelligence dashboards are being replaced by the Intelligence
// page, so the Dashboard hides their tabs and skips their setup work. One flag so this
// is a single line to reverse; the dashboard service and route resolve both honour it.
export const HIDE_BUSINESS_INTELLIGENCE_TABS = true;
